/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "button_add": [{
    "type": 0,
    "value": "Hinzufügen"
  }],
  "button_remove_all": [{
    "type": 0,
    "value": "Alle entfernen"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var deDE = Object.assign(TranslationProviderComponent, {
  translations
});

export { deDE as d };
//# sourceMappingURL=de-DE-BffIX9aW.js.map
